import { Observable, map, switchMap } from 'rxjs';
import {
  ListWa_OverviewArticlesQuery,
  ListWa_OverviewArticlesQueryVariables,
  ListWa_OverviewOrdersQuery,
  ListWa_OverviewOrdersQueryVariables,
  SavePositionsInMultipleOrdersMutationVariables,
  SavePositionsInMultipleOrdersMutation,
} from '../../../graphql/generatedModel';
import { Pub, Service, Sub } from '../../../shared/services/service.abstract';
import { gqlClient } from '../../../graphql/graphqlRequest';
import {
  getOverviewArticles,
  getOverviewOrders,
  savePositionsInMultipleOrders,
} from './gql/overview.gql';

type Actions = 'getOverviewOrders' | 'getOverviewArticles' | 'savePositionsInMultipleOrders';

class PubImpl extends Pub<Actions> {
  getOverviewOrders(params: ListWa_OverviewOrdersQueryVariables) {
    this.emit('getOverviewOrders', params);
  }
  getOverviewArticles(params: ListWa_OverviewArticlesQueryVariables) {
    this.emit('getOverviewArticles', params);
  }
  savePositionsInMultipleOrders(params: SavePositionsInMultipleOrdersMutationVariables) {
    this.emit('savePositionsInMultipleOrders', params);
  }
}

class SubImpl extends Sub<Actions> {
  getOverviewOrders(): Observable<OverviewOrdersRes> {
    return this.actionListener('getOverviewOrders').pipe(
      switchMap(({ params }) => {
        return gqlClient(getOverviewOrders, params) as Observable<ListWa_OverviewOrdersQuery>;
      }),
      map((data: ListWa_OverviewOrdersQuery) => {
        return data.wawiAssist?.listWA_OverviewOrders as OverviewOrdersRes;
      }),
    );
  }
  getOverviewArticles(): Observable<OverviewArticlesRes> {
    return this.actionListener('getOverviewArticles').pipe(
      switchMap(({ params }) => {
        return gqlClient(getOverviewArticles, params) as Observable<ListWa_OverviewArticlesQuery>;
      }),
      map((data: ListWa_OverviewArticlesQuery) => {
        return data.wawiAssist?.listWA_OverviewArticles as OverviewArticlesRes;
      }),
    );
  }
  savePositionsInMultipleOrders(): Observable<SavePositionsInMultipleOrdersMutationRes> {
    return this.actionListener('savePositionsInMultipleOrders').pipe(
      switchMap(({ params }) => {
        return gqlClient(
          savePositionsInMultipleOrders,
          params,
        ) as Observable<SavePositionsInMultipleOrdersMutation>;
      }),
      map((data: SavePositionsInMultipleOrdersMutation) => {
        return data.wawiAssist
          ?.saveWA_PositionsInMultipleOrders as SavePositionsInMultipleOrdersMutationRes;
      }),
    );
  }
}

class OverviewService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const overviewService = new OverviewService();

export type OverviewOrdersRes = NonNullable<
  NonNullable<ListWa_OverviewOrdersQuery>['wawiAssist']
>['listWA_OverviewOrders'];

export type OverviewArticlesRes = NonNullable<
  NonNullable<ListWa_OverviewArticlesQuery>['wawiAssist']
>['listWA_OverviewArticles'];

export type SavePositionsInMultipleOrdersMutationRes = NonNullable<
  NonNullable<SavePositionsInMultipleOrdersMutation>['wawiAssist']
>['saveWA_PositionsInMultipleOrders'];
